import {PillTag} from 'components/system/pilltag';
import {PillTagGroup} from 'components/system/pilltag_group';

export const Summary = ({summary}: Props) => {
  return (
    <PillTagGroup>
      <PillTag color='greyLight'>Total tests: {summary.total}</PillTag>
      <PillTag color={summary.passed > 0 ? 'green' : 'greyLight'}>Passed: {summary.passed}</PillTag>
      <PillTag color={summary.failed > 0 ? 'red' : 'greyLight'}>Failed: {summary.failed}</PillTag>
    </PillTagGroup>
  );
};

type Props = {
  summary: CodeRunSummary;
};
